import React from 'react';
import { Routes, Route } from '@leagueplatform/routing';
import {
  getModulePath,
  LEAGUE_MODULE_NAMES,
} from '@leagueplatform/league-routes';
import { CareCollection } from './pages/care-collection/care-collection.page';
import { CareCollections } from './pages/care-collections/care-collections.page';

export const CareCollectionsRoutes = (): JSX.Element => (
  <Routes>
    <Route index element={<CareCollections />} />
    <Route path=":careCollectionId/*" element={<CareCollection />} />
  </Routes>
);

export const CareCollectionsRoutesBrowserRouter = [
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.careCollections)}/*`,
    element: <CareCollections />,
  },
  {
    path: `${getModulePath(
      LEAGUE_MODULE_NAMES.careCollections,
    )}/:careCollectionId`,
    element: <CareCollection />,
  },
];
